module.exports = __webpack_public_path__ + "6bb0c0cc611c1bc11dd185f974d2d5e9.pdf";